export default __webpack_public_path__ + "static/media/visao.925acdef.png";